
export const GreenField = `
  background-color: rgba(115, 115, 45, 0.25);
  border-color: rgba(101, 182, 100, 0.64);
`
export const BlueField = `
  background-color: rgba(115, 115, 202, 0.25);
  border-color: rgba(80, 80, 241, 0.64);
`
export const BlueFieldTransparent = `
  border-color: rgba(80, 80, 241, 0.64);
`
export const GreenTransparent = `
  background-color: rgba(115, 115, 45, 0.01);
  border-color: rgba(66, 244, 80, 0.8);
`



// WEBPACK FOOTER //
// ./src/constants/overlayStyles.js